import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { slideInOutAnimation } from 'projects/nine-gold-lib/src/lib/animations/slide-in-out.animation';
import { ProductService } from 'projects/nine-gold-lib/src/lib/services/product.service';
import { ConfirmDialogService } from 'projects/nine-gold-lib/src/lib/shared/confirm-dialog/confirm-dialog.service';
import { UserInterfaceService } from 'projects/nine-gold-lib/src/lib/services/user-interface.service';
import { faTimes } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-paypal-form',
  templateUrl: './paypal-form.component.html',
  styleUrls: ['./paypal-form.component.scss'],
    animations: [slideInOutAnimation],
    host: { '[@slideInOutAnimation]': '' }
})
export class PaypalFormComponent implements OnInit {
  formDirty = false;
  faTimesIcon = faTimes;
  redirectUrl: string;
  open = false;
  productCode: string;

  constructor(
    private route: ActivatedRoute,
    // private location: Location,
    private router: Router,
    private productService: ProductService,
    private confirmService: ConfirmDialogService,
    private uiService: UserInterfaceService
  ) { }

  ngOnInit(): void {
    this.redirectUrl = this.route.snapshot.queryParams['returnUrl'];
    this.productCode = this.route.snapshot.queryParams['pcode'];
  }

  ngAfterViewInit():void {
    this.open = true;
  }

  ngOnDestroy(): void {
    this.open = false;
  }

  clickToClose(event): void {
    let formContainer = document.getElementById('quoteContainer');
    if(event.target !== formContainer || formContainer.contains(event.target)) {
    }
  }

  formDirtyChange(dirty): void {
    this.formDirty = dirty;
  }

  goBack(): void {
    this.router.navigate(
			[
        "../",
				{
					outlets: {
            sidePopup: null
					}
				}
      ],
			{
				relativeTo: this.route.parent
			}
		);

  }

}
